import React from "react";
import { DatePicker } from "antd";

function MyDatePicker(props) {
  return <DatePicker {...props} />;
}

export default MyDatePicker;
